export default __webpack_public_path__ + "static/media/import-blue.91029744.svg";